module.exports = __webpack_public_path__ + "img/amazon.6bd67bb2.svg";